import {InputText} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import {FormChooseExternal} from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemAms} from '../AM/FormChooseAm.jsx'
import Model from './ModelDo.mjs'

export const FormItemDoName = props => (
    <FormItemBizProp
        Model={Model}
        prop="doName"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemDoNo = props => (
    <FormItemBizProp
        Model={Model}
        prop="doNo"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseDo(props) {
    return (
        <FormChooseExternal {...props}>
            <FormItemAms />
            <FormItemDoNo />
            <FormItemDoName />
        </FormChooseExternal>
    )
}
